import { Component, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { CardView } from 'src/app/interfaces/cardview';

@Component({
    selector: 'app-payments',
    templateUrl: './payments.component.html',
    styleUrls: ['./payments.component.scss'],
    standalone: false
})
export class PaymentsComponent implements OnInit {

  constructor() { }

  eventsSubject: Subject<string> = new Subject<string>();
  parentRow:CardView = {};
  condition:string = '0=0'
  ngOnInit(): void {
    
  }


  onTabChanged(tabId: string){
    this.eventsSubject.next(tabId);
  }
}
